const locale = {
  id: 'ContactNotesConstant',
  code: 'CN',
  text: {
    "./images/note-eng.jpg": "./images/note-cn.jpg",
    'Contact Notes': '联系人备忘',
    'Here you can track the progress of your communication with your contacts and create notes for late review': '在这里您可以追踪记录您与联系人交流的经过，建立备忘，方便之后进行复查。',
  }
}

export const onBoardingContents = {
  title: __('Contact Notes', locale),
  text: __('Here you can track the progress of your communication with your contacts and create notes for late review', locale),
  image: require(__('./images/note-eng.jpg', locale)),
  showArrow: true,
}



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/ContactNotes/constant.js